import styled from 'styled-components';

export const ContainerStyled = styled.div`
  width: 72px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const NoneBugsText = styled.p`
  color: var(--ds-text-subtle, var(--ds-fb-text-subtle));
  font-weight: 400;
  font-style: italic;
`;
